/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import OrderTemplateLines from './modules/order-template/order-template';
import OrderTemplateLinesView from './modules/order-template/order-template.view';

export * from './modules/order-template/components';
export * from './modules/order-template/order-template';
export * from './modules/order-template/order-template.data';
export * from './modules/order-template/order-template.view';

// Export * from './modules/order-template/actions';
export * from './modules/order-template/order-template.props.autogenerated';
export * from './modules/order-template-list/components';
export * from './modules/order-template-list/order-template-list';
export * from './modules/order-template-list/order-template-list.data';
export * from './modules/order-template-list/order-template-list.view';

export {
    OrderTemplateLines,
    OrderTemplateLinesView
};
